import * as React from 'react';
import { observer } from 'mobx-react';
import { DesktopLiveEventListStore, IOdd, MtsTicketStore, IDesktopLiveEventListStore, OfferType, StatisticsInApi, IScreenInfo, gameDetailStore, gameStore } from 'eTip--common';
import { EventStatsTipos } from "./../../api/eventStats";
import { translation, translationForMts } from 'easit--localization';
import { LiveEventInfo, EventOdds } from 'desktop--design-library';
import { Instance } from 'mobx-state-tree';

export interface ILiveEventListItemContainerProps {
    eventApiData: Instance<typeof DesktopLiveEventListStore>;
    ticketWrapper: Instance<typeof MtsTicketStore>;
    onSetFavorite: (event: IDesktopLiveEventListStore, value: boolean) => void | null;
    canShowSportIcon: boolean;
    isFavorite?: boolean;
    onGoToDetail: (id: number) => void;
    onShowDetail: (eventId: number) => void;
    isDetailOpened: boolean;
    isDetailOpenedBelow: boolean;
    isMatchTracker: boolean;
    matchTrackerClick: () => void;
    isLiveStream: boolean;
    liveStreamClick: () => void;
    isLiveInPrematch: boolean;
    screenInfo: IScreenInfo;
    gameAndDetailProvider: (eventApiData: Instance<typeof DesktopLiveEventListStore>) => { game: Instance<typeof gameStore>, detail: Instance<typeof gameDetailStore> } | null;
}

@observer
export class LiveEventListItemContainer extends React.Component<ILiveEventListItemContainerProps> {

    get eventApiData(): Instance<typeof DesktopLiveEventListStore> {
        return this.props.eventApiData;
    }

    render() {
        const event = this.eventApiData;
        let gameAndDetail = this.props.gameAndDetailProvider(event);
        return <div className={`live-eventlist-item ${this.props.isDetailOpened ? 'with-detail-opened' : ''} ${this.props.isLiveInPrematch ? 'live-in-prematch' : ''}`} onClick={() => { this.props.onShowDetail(event.id) }} style={{ cursor: "pointer" }} data-test-role="event-list__item">
            <LiveEventInfo
                id={event.id}
                name={event.name}
                competitors={event.competitors}
                stateName={event.stateName}
                detailsCount={event.detailsCount}
                hasResults={event.hasResults}
                mainResult={event.mainResult}
                importantResults={event.resultsOfPeriods}
                onGoToDetail={this.props.onGoToDetail}
                onShowDetail={() => { this.props.onShowDetail(event.id); }}
                stateTime={event.stateTime}
                canShowIcon={this.props.canShowSportIcon}
                graphicsPresentationId={event.graphicsPresentationId}
                setFavoriteEvent={this.props.onSetFavorite ? (value: boolean) => this.props.onSetFavorite(event, value) : null}
                isFavorite={this.props.isFavorite}
                isDetailOpened={this.props.isDetailOpened}
                isDetailOpenedBelow={this.props.isDetailOpenedBelow}
                categoryPath={event.categoryPath}
                isMatchTracker={this.props.isMatchTracker}
                matchTrackerClick={this.props.matchTrackerClick}
                isLiveStream={this.props.isLiveStream}
                liveStreamClick={this.props.liveStreamClick}
                gameName={gameAndDetail ? gameAndDetail.game.name : ''}
                gameInfo={gameAndDetail?.game.info}
                statistics={event.statistics}
                onStatisticsAction={(statistics: StatisticsInApi, eventName: string) => { const stats = new EventStatsTipos(); stats.viewStatistics(statistics, eventName) }}
                isLiveInPrematch={this.props.isLiveInPrematch}
                screenInfo={this.props.screenInfo}
            >
                {
                    (gameAndDetail) &&
                    <EventOdds
                        activeTips={this.props.ticketWrapper.activeTips}
                        inactiveTips={this.props.ticketWrapper.inactiveTips}
                        gameDetail={gameAndDetail.detail}
                        setTipOnCoupon={(odd: IOdd) => this.props.ticketWrapper.oddsSetTipOnCouponAsync(
                            odd,
                            {
                                eventName: event.name,
                                eventDate: event.startDate,
                                gameName: gameAndDetail.game.name,
                                hasDetail: gameAndDetail.game.hasDetails,
                                detailName: gameAndDetail.detail.name,
                                number: gameAndDetail.detail.number,
                                offerType: OfferType.Live
                            })}
                    />
                }

                {
                    /*  Erika, no for MTS  !gameAndDetail && event.detailsCount > 0 &&
                       <OtherDetails onGoToDetail={() => pushToEventDetail(event.id)} />*/
                }

                {
                    !gameAndDetail && event.detailsCount === 0 &&
                    <div className="text-center">{translation().live_noRates}</div>
                }

                {
                    __IsMTS__ && !gameAndDetail && event.detailsCount > 0 &&
                    <div className="text-center">{translationForMts().live_seeOddsInDetail}</div>
                }
            </ LiveEventInfo>
        </div >
    }
}